import Vue from 'vue';

import i18n from '@/libs/i18n';
import store from '@/libs/store';
import router from '@/libs/router';

import Helpers from '@/mixins/Helpers';


const HelpersClass = Vue.extend(Helpers);
const HelpersInstance = new HelpersClass({
    i18n,
    router,
    store,
});

Vue.mixin({
    constants: {
        $: HelpersInstance,
        _,
        debug,
    },
});

export default HelpersInstance;
